import type { Components } from '@mui/material/styles';

export default function MuiCssBaseline(): Components['MuiCssBaseline'] {
  return {};
}
